import { Reducer } from 'redux'
import { ActionTypes, InfoState, initialState } from './types'

const reducer: Reducer<InfoState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ACCOUNT_INFO_REQUEST: {
      return {
        ...state,
        loadingAccountInfo: true,
        setSignedContentResponse: undefined,
      }
    }
    case ActionTypes.ACCOUNT_INFO_FULFILLED: {
      return {
        ...state,
        accountDetailedInfo: action.payload.data,
        loadingAccountInfo: false,
      }
    }
    case ActionTypes.ACCOUNT_INFO_REJECTED: {
      return {
        ...state,
        loadingAccountInfo: false,
        errorDescription: action.payload.response.data.message,
      }
    }

    case ActionTypes.USER_ENVELOPE_PROCESS_REQUEST: {
      return {
        ...state,
        loadingUserEnvelopeSign: true,
        errorDescription: undefined,
      }
    }
    case ActionTypes.USER_ENVELOPE_PROCESS_FULFILLED: {
      return {
        ...state,
        loadingUserEnvelopeSign: false,
        setSignedContentResponse: action.payload.data,
        envelopeQuery: undefined,
      }
    }
    case ActionTypes.CHANGE_SELECTED_PRODUCT: {
      return {
        ...state,
        setSignedContentResponse: undefined,
        gibApplicationQuery: undefined,
      }
    }
    case ActionTypes.USER_ENVELOPE_PROCESS_REJECTED: {
      return {
        ...state,
        loadingUserEnvelopeSign: false,
      }
    }
    case ActionTypes.ENVELOPE_QUERY_REQUEST: {
      return {
        ...state,
        envelopeQuery: {
          ...state.envelopeQuery,
          envelopeQuering: true,
          envelopeStatus: undefined,
        },
      }
    }
    case ActionTypes.ENVELOPE_QUERY_FULFILLED: {
      return {
        ...state,
        envelopeQuery: {
          ...state.envelopeQuery,
          envelopeQuering: false,
          envelopeStatus: action.payload.data,
        },
      }
    }
    case ActionTypes.GIB_APPLICATION_QUERY_REQUEST: {
      return {
        ...state,
        gibApplicationQuery: {
          ...state.gibApplicationQuery,
          isQuerying: true,
          response: undefined,
        },
      }
    }

    case ActionTypes.GIB_APPLICATION_QUERY_FULFILLED: {
      return {
        ...state,
        gibApplicationQuery: {
          ...state.gibApplicationQuery,
          isQuerying: false,
          response: action.payload,
        },
      }
    }

    default: {
      return state
    }
  }
}

export default reducer
